export function cloneDeep<T>(value: T): T {
  return JSON.parse(JSON.stringify(value));
}

export function isDeepEqual(value, other) {
  return JSON.stringify(value) === JSON.stringify(other);
}

export function isShallowEqual(value, other) {
  const keys1 = Object.keys(value);
  return keys1.length === Object.keys(other).length && keys1.every(key => Object.prototype.hasOwnProperty.call(other, key) && value[key] === other[key]);
}

export function isShallowMatch(value, other) {
  const keys1 = Object.keys(value);
  return keys1.every(key => Object.prototype.hasOwnProperty.call(other, key) && value[key] === other[key]);
}

export function isShallowSame(value, other) {
  const keys1 = Object.keys(value);
  return keys1.length === Object.keys(other).length && keys1.every(key => Object.prototype.hasOwnProperty.call(other, key));
}

export function isShallowSimilar(value, other) {
  const keys1 = Object.keys(value);
  return keys1.every(key => Object.prototype.hasOwnProperty.call(other, key));
}

export function sortProperties(value) {
  return value instanceof Object && !(value instanceof Array) ? Object.keys(value).sort().reduce((sorted, key) => (sorted[key] = value[key], sorted), {}) : value;
}
